export default "__VITE_ASSET__D68ycs6x__"